import React from "react";
import { Trans, useTranslation } from "@coworker/locales";
import IngkaButton from "@ingka/button";
import { SettingsCard } from "./SettingsCard";
import { useFetchShoppingtoolsSettings } from "../Hooks/useFetchShoppingtoolsSettings";
import { useCountryId, useStoreId } from "../../../core/auth/useLoggedInUser";
import { findSettingsObject, getCurrency } from "../helper";
import { DIVISION_HASH } from "../constants";
import { useLocation } from "react-router-dom";
import { useWorkspacesAction } from "../../../hooks/useWorkspaces";
import { useCreateOrUpdateShoppingtoolsSettings } from "../Hooks/useCreateOrUpdateShoppingtoolsSettings";
import { SettingsDefault, SettingsResponse } from "../Types";
import FullScreenPopup from "@coworker/apprestructured/src/layout/components/FullScreenPopup/FullScreenPopup";

export const ShoppingToolsSettings = () => {
  const [settingsList, setSettingsList] = React.useState<
    SettingsDefault[] | SettingsResponse[]
  >([]);
  const { data: settings, isFetching } = useFetchShoppingtoolsSettings();
  const { push } = useWorkspacesAction();
  const { t } = useTranslation();
  const storeId = useStoreId();
  const location = useLocation();
  const countryId = useCountryId();
  const currency = getCurrency(countryId);
  const createOrUpdateSettingsMutation =
    useCreateOrUpdateShoppingtoolsSettings();
  const previousUrl = location.state?.stacks[0][0].path;

  React.useEffect(() => {
    setSettingsList(settings ?? []);
  }, [settings]);

  if (!settingsList) return null;

  const createOrUpdateSettings = async () => {
    const updatedSettingsList: SettingsResponse[] | SettingsDefault[] =
      settingsList?.map((setting) => {
        return {
          ...setting,
          store_id: storeId,
          currency: currency || "",
        };
      });

    await createOrUpdateSettingsMutation.mutateAsync(updatedSettingsList);
    push(previousUrl);
  };

  return (
    <FullScreenPopup
      actionBarContent={
        <IngkaButton
          type="primary"
          text={<Trans>saveString</Trans>}
          disabled={!settingsList.length}
          onClick={createOrUpdateSettings}
        />
      }
      appBarConfig={{
        title: t("settingsString"),
        actions: [],
      }}
      noPadding
    >
      <SettingsCard
        title={"availableAtShowroomString"}
        id={DIVISION_HASH.SHOWROOM?.division ?? ""}
        divisionSettings={
          findSettingsObject(
            settingsList,
            DIVISION_HASH.SHOWROOM?.division ?? ""
          )!
        }
        setSettingsList={setSettingsList}
        settingsList={settingsList}
        loading={isFetching}
      />
      <SettingsCard
        title={"availableAtMarkethallOTWString"}
        id={DIVISION_HASH.MARKETHALL?.division ?? ""}
        divisionSettings={
          findSettingsObject(
            settingsList,
            DIVISION_HASH.MARKETHALL?.division ?? ""
          )!
        }
        setSettingsList={setSettingsList}
        settingsList={settingsList}
        loading={isFetching}
      />
      <SettingsCard
        title={"availableAtCashlineString"}
        id={DIVISION_HASH.CASHLINE?.division ?? ""}
        divisionSettings={
          findSettingsObject(
            settingsList,
            DIVISION_HASH.CASHLINE?.division ?? ""
          )!
        }
        setSettingsList={setSettingsList}
        settingsList={settingsList}
        loading={isFetching}
      />
    </FullScreenPopup>
  );
};
